
import {
  defineComponent, inject, onMounted, ref, watch,
} from 'vue';
import RefreshPull from 'pull-refresh-vue3';
// eslint-disable-next-line import/no-cycle
import { useRouter } from 'vue-router';
// eslint-disable-next-line import/no-cycle
import { useAlertsStore } from '../store/alertsStore';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
// eslint-disable-next-line import/no-cycle
import { useDriveStore } from '@/modules/drive/store/driveStore';

import AlertsNotification from '../components/AlertsNotification.vue';
import AppHeader from '@/components/AppHeader.vue';
// import AppPhotoView from '@/components/AppPhotoView.vue';
import AppFileView from '@/components/AppFileView.vue';
import AppMediaView from '@/components/AppMediaView/AppMediaView.vue';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';
import UsePullToRefresh from '@/composables/UsePullToRefresh';
import AppNoMessage from '@/components/AppNoMessage.vue';
import DesktopHeader from '@/components/desktop/DesktopHeader.vue';
// eslint-disable-next-line import/no-cycle
import UserService from '@/services/UserService';
import UsePagination from '@/composables/UsePagination';
import { DIRECTION } from '@/helpers/isScrollEnd';
import { INotificationRead } from '@/types/interfaces';
import { NOTIFICATION_READ_MODE, NOTIFICATION_TYPE } from '@/types/enums';
import DriveAsideMainMenu from '@/modules/drive/components/desktop/DriveAsideMainMenu.vue';

export default defineComponent({
  components: {
    DriveAsideMainMenu,
    AlertsNotification,
    AppHeader,
    // AppPhotoView,
    AppFileView,
    RefreshPull,
    // AppSkeletonAlert,
    AppMediaView,
    AppNoMessage,
    DesktopHeader,
  },
  setup() {
    const driveStore = useDriveStore();
    const alertStore = useAlertsStore();
    const mainStore = useMainStore();
    const router = useRouter();
    // const dataLoading: Ref<boolean> = ref(true);
    // eslint-disable-next-line @typescript-eslint/ban-types
    const $localize = inject('$localize') as Function;

    const dataLoading = ref(true);
    const {
      scroller, isPageLoading, onCacheScroll,
    } = UsePagination();

    function closeFullScreen() {
      driveStore.fullscreenPhoto = undefined;
      driveStore.fullscreenFile = undefined;
      driveStore.appPhotoViewMedia = undefined;
    }

    function decreaseBadgesByAlertType(alertType: string) {
      if (alertType === NOTIFICATION_TYPE.IN_GROUP_REQUEST_SENT) {
        mainStore.badgesInGroup -= 1;
      }
      if (alertType === NOTIFICATION_TYPE.GROUP_REQUEST_SENT) {
        mainStore.badgesGroup -= 1;
      }
      if (alertType === NOTIFICATION_TYPE.CONTACT_REQUEST_SENT) {
        mainStore.badgesContact -= 1;
      }
    }

    function handleBack() {
      router.back();
    }

    function readNotification() {
      const payload: INotificationRead[] = [];
      alertStore.notifications.data.forEach((alert) => {
        if (alert.id && !alert.read) {
          // eslint-disable-next-line no-param-reassign
          alert.read = true;
          payload.push({
            id: alert.id,
            mode: NOTIFICATION_READ_MODE.BY_ID,
          });
          decreaseBadgesByAlertType(alert.type);
        }
      });
      if (payload.length) {
        UserService.readNotification(payload);
        mainStore.badgesAlert -= payload.length;
      }
    }

    function refreshAlerts() {
      return alertStore.fetchNotifications(true).then((response) => {
        readNotification();
        return response;
      });
    }

    async function fetchCacheData() {
      return alertStore.fetchNotifications();
    }

    function handleScroll() {
      onCacheScroll(fetchCacheData, DIRECTION.BOTTOM, alertStore.notifications.lastPage, alertStore.notifications.page);
    }

    const {
      loadingPull, loosingText, successText, pullingText, loadingText, onRefresh,
    } = UsePullToRefresh(refreshAlerts);

    watch(() => alertStore.notifications.data.length, () => {
      readNotification();
    });

    onMounted(() => {
      MonitoringService.sendPageMountedSpeed();
      readNotification();
    });

    return {
      // dataLoading,
      alertStore,
      driveStore,
      closeFullScreen,

      loadingPull,
      loosingText,
      successText,
      pullingText,
      loadingText,
      onRefresh,
      scroller,
      isPageLoading,
      handleScroll,
      mainStore,
      handleBack,
    };
  },

});
